import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import style from "./index.module.scss";

import Api from "@/common/Api/accountManage";
import { getRegionData } from "@/common/utils/reginUtil";
import { rootContext, globalData } from "@/context/rootContext";

import { signUpLanguageData } from "@/assets/data/pageData";

function SignUp() {

  const navigate = useNavigate();
  const { setEnterRegion } = useContext(rootContext);

  const initRegionCode = async (region) => {
    getRegionData(region);

    const res = await Api.getRegionData();
    if (res.status === 200) {
      globalData.regionConfigId = res.data.regionConfigId;
      setEnterRegion(region);
      navigate("/signup");
    }
  };

  const enterMultSignUp = () => {
    window.gtag("event", "pc_sign_mult");
    initRegionCode("mult");
  };

  const enterEnglistSignUp = () => {
    window.gtag("event", "pc_sign_en");
    initRegionCode("en");
  };

  const enterSeaSignUp = () => {
    window.gtag("event", "pc_sign_sea");
    window.gtag("event", "pc_sign_sea_fl84");
    initRegionCode("sea");
  };

  return (
    <section>
      <div className={style.sing_up_main}>
        <p className={style.title}>{ signUpLanguageData.title }</p>
        <div className={style.require_box}>
          <p className={style.language_tip}>{ signUpLanguageData.desc }</p>
          <div className={style.language_list}>
            <div className={style.language_btn1} onClick={enterEnglistSignUp}>
              <p className={style.btn_title}>
                {signUpLanguageData.langEn.map((item, index) => <p key={index}>{item}</p>)}
              </p>
            </div>
            <div className={style.language_btn2} onClick={enterMultSignUp}>
              <p className={style.btn_desc}>
                {signUpLanguageData.langMult.map((item, index) => <p key={index}>{item}</p>)}
              </p>
            </div>
            <div className={style.language_btn3} onClick={enterSeaSignUp}>
              <p className={style.btn_desc}>
                {signUpLanguageData.langSea.map((item, index) => <p key={index}>{item}</p>)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignUp;
